import { DeepPartial } from '@apollo/client/utilities'
import { BankingCardApprovableMetadataFragment } from 'generated/resources/graphql'

import MoneyWithCurrency from 'modules/core/lib/money'

import { translatePeriod } from './helpers'

export const getBankingCardMetadata = (
  data: DeepPartial<BankingCardApprovableMetadataFragment>
) => {
  const accessLocale = data.cardholder?.employee?.access?.locale ?? 'en'

  const displayLimitAmount = data.cardLimit?.limitForCurrentPeriod
    ? MoneyWithCurrency({
        amount: data.cardLimit.limitForCurrentPeriod,
        currency: data.cardLimit?.currency,
        locale: accessLocale,
      })
    : undefined

  const translatedPeriod = data.cardLimit?.period
    ? translatePeriod(data.cardLimit.period)
    : undefined

  const displayBudget = displayLimitAmount
    ? `${displayLimitAmount} ${translatedPeriod?.toLowerCase()}`
    : undefined

  return [displayBudget, data.description].filter(Boolean)
}
